import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

// Записывает объект в хранилище sessionStorage
export const setSessionStorageByKey = (key: string, params: Record<string, any>): boolean => {
    if (isServerSide()) {
        return false;
    }

    try {
        sessionStorage.setItem(key, JSON.stringify(params));
        return true;
    } catch {
        return false;
    }
};

// Возвращает объект из хранилища sessionStorage
export const getSessionStorageByKey = (key: string): Record<string, string> | null => {
    if (isServerSide()) {
        return null;
    }

    try {
        const values = sessionStorage.getItem(key);
        return values ? JSON.parse(values) : null;
    } catch {
        return null;
    }
};

// Возвращает объект из хранилища с нужным типом
export const getSessionStorageDataWithTypes = <T>(key: string): T | null => {
    if (isServerSide()) {
        return null;
    }

    const dataString = sessionStorage.getItem(key);

    if (dataString) {
        const parsedData: T = JSON.parse(dataString);
        return parsedData;
    }
    return null;
};

// Удаляет объект из хранилища по ключу
export const removeSessionStorageDataByKey = (key: string): void => {
    if (!isServerSide()) {
        sessionStorage.removeItem(key);
    }
};
